import { useState } from 'react';
import { NetflixRow } from './NetflixRow';
import { Play, ExternalLink } from 'lucide-react';

export const VideoRow = () => {
  const [playingVideo, setPlayingVideo] = useState(null);

  const videos = [
    {
      title: "SANS Cybersecurity Leadership Summit",
      subtitle: "Strategic Risk Management Panel • 2024",
      description: "Leading panel discussion on Strategic Risk Management in the Age of AI at SANS Cybersecurity Leadership Summit. Deep dive into AI governance frameworks, regulatory compliance strategies, and enterprise risk management approaches for emerging technologies.",
      videoId: "p_2x324zKf8",
      youtubeUrl: "https://www.youtube.com/watch?v=p_2x324zKf8&list=PLtgaAEEmVe6Bnuq43jxYufUue0R7jPhFk&index=4",
      thumbnail: `https://img.youtube.com/vi/p_2x324zKf8/maxresdefault.jpg`,
      tags: ["SANS", "AI Risk", "Panel Discussion", "Leadership Summit"]
    },
    {
      title: "CSA Cloud Threats & Vulnerabilities Summit",
      subtitle: "Cloud Security Controls Framework • 2024",
      description: "Comprehensive presentation on Cloud Security Controls Matrix v4.0 implementation and best practices. Covering shared responsibility models, automated compliance monitoring, and enterprise cloud security governance at global scale.",
      videoId: "2lzTBVvfwnM",
      youtubeUrl: "https://www.youtube.com/watch?v=2lzTBVvfwnM&list=PLFkoMPnn5qsvdrt6b-M0X6WAOMFZiGhWw&index=15",
      thumbnail: `https://img.youtube.com/vi/2lzTBVvfwnM/maxresdefault.jpg`,
      tags: ["CSA", "Cloud Security", "CCM v4.0", "Technical Presentation"]
    }
  ];

  const VideoCard = ({ video, index }) => {
    const [imageError, setImageError] = useState(false);
    const isPlaying = playingVideo === index;

    const handlePlayClick = (e) => {
      e.stopPropagation();
      setPlayingVideo(isPlaying ? null : index);
    };

    const handleCardClick = () => {
      window.open(video.youtubeUrl, '_blank');
    };

    return (
      <div className="netflix-card cursor-pointer" onClick={handleCardClick}>
        <div className="relative netflix-card-image group">
          {!isPlaying ? (
            <>
              {!imageError ? (
                <img 
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover"
                  onError={() => setImageError(true)}
                />
              ) : (
                <div className="flex items-center justify-center h-full bg-gradient-to-br from-netflix-red to-netflix-gray-200">
                  <Play className="w-12 h-12 text-white" />
                </div>
              )}
              
              {/* Play Button Overlay */}
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <button 
                  onClick={handlePlayClick}
                  className="bg-white/90 hover:bg-white rounded-full p-4 transition-colors duration-200"
                >
                  <Play className="w-8 h-8 text-black fill-current" />
                </button>
              </div>
              
              {/* Duration Badge */}
              <div className="absolute bottom-2 right-2 bg-black/80 text-white text-xs px-2 py-1 rounded">
                HD
              </div>
            </>
          ) : (
            <div className="relative w-full h-full bg-black">
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${video.videoId}?autoplay=1&controls=1&modestbranding=1`}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute inset-0"
              />
            </div>
          )}
        </div>
        
        <div className="netflix-card-content">
          <div className="netflix-card-title">{video.title}</div>
          <div className="netflix-card-subtitle">{video.subtitle}</div>
          
          <div className="mb-2">
            {video.tags.map((tag, tagIndex) => (
              <span key={tagIndex} className="netflix-badge netflix-badge-secondary mr-1 mb-1">
                {tag}
              </span>
            ))}
          </div>
          
          <div className="netflix-card-description">{video.description}</div>
          
          <div className="mt-3 flex items-center space-x-2">
            <button 
              onClick={handlePlayClick}
              className="flex items-center space-x-1 text-netflix-red hover:text-white transition-colors text-sm"
            >
              <Play className="w-4 h-4" />
              <span>{isPlaying ? 'Playing' : 'Play Video'}</span>
            </button>
            <span className="text-netflix-gray-400">•</span>
            <button 
              onClick={(e) => {
                e.stopPropagation();
                window.open(video.youtubeUrl, '_blank');
              }}
              className="flex items-center space-x-1 text-netflix-gray-400 hover:text-white transition-colors text-sm"
            >
              <ExternalLink className="w-4 h-4" />
              <span>Watch on YouTube</span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <NetflixRow title="Speaking Engagements & Presentations" id="videos">
      {videos.map((video, index) => (
        <VideoCard key={index} video={video} index={index} />
      ))}
    </NetflixRow>
  );
};